import { MapCoordinates } from '@freelancer/datastore/core';
import { Country, generateCountryObject } from '../countries';
import { generateProfileViewUserObjects } from '../profile-view-users';
import { Skill } from '../skills';
import { User } from '../users';
import { SearchUser } from './search-users.model';

export interface GenerateSearchUsersOptions {
  readonly users: readonly User[];
  readonly avatar?: string;
  readonly country?: Country;
  readonly hourlyRate?: number;
  readonly isOnline?: boolean;
  readonly rating?: number;
  readonly reviews?: number;
  readonly searchCoordinates?: MapCoordinates;
  readonly skills?: readonly Skill[];
}

export function generateSearchUsersObjects({
  avatar,
  country = generateCountryObject(),
  hourlyRate = 2, // HourlyRateFilterRange.MINIMUM
  isOnline = false,
  rating = 5,
  reviews = 0,
  searchCoordinates,
  skills = [],
  users,
}: GenerateSearchUsersOptions): readonly SearchUser[] {
  const profileViewUser = generateProfileViewUserObjects({
    users,
  });

  return profileViewUser.map(user => ({
    ...user,
    avatar,
    country,
    hourlyRate,
    isOnline,
    rating,
    reviews,
    searchCoordinates,
    skills,
  }));
}
